/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FlightCredit
 */
export interface FlightCredit {
    /**
     * 
     * @type {string}
     * @memberof FlightCredit
     */
    id?: string;
    /**
     * IATA airline code (e.g. UA, DL, AA)
     * @type {string}
     * @memberof FlightCredit
     */
    airline?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlightCredit
     */
    creditType?: FlightCreditCreditTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FlightCredit
     */
    creditNumber?: string | null;
    /**
     * Original face value
     * @type {number}
     * @memberof FlightCredit
     */
    amount?: number;
    /**
     * ISO 4217 currency code
     * @type {string}
     * @memberof FlightCredit
     */
    currency?: string;
    /**
     * Current usable balance
     * @type {number}
     * @memberof FlightCredit
     */
    remainingAmount?: number;
    /**
     * 
     * @type {Date}
     * @memberof FlightCredit
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FlightCredit
     */
    status?: FlightCreditStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FlightCredit
     */
    originalConfirmationNumber?: string | null;
    /**
     * How this credit was created
     * @type {string}
     * @memberof FlightCredit
     */
    source?: FlightCreditSourceEnum;
    /**
     * User-provided notes (manual credits only)
     * @type {string}
     * @memberof FlightCredit
     */
    notes?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FlightCredit
     */
    createdAt?: Date;
}


/**
 * @export
 */
export const FlightCreditCreditTypeEnum = {
    FlightCredit: 'flight_credit',
    Ecredit: 'ecredit',
    TripCredit: 'trip_credit',
    TravelFund: 'travel_fund',
    WalletCredit: 'wallet_credit',
    TravelBankCredit: 'travel_bank_credit',
    ElectronicTravelCertificate: 'electronic_travel_certificate',
    Voucher: 'voucher',
    Refund: 'refund'
} as const;
export type FlightCreditCreditTypeEnum = typeof FlightCreditCreditTypeEnum[keyof typeof FlightCreditCreditTypeEnum];

/**
 * @export
 */
export const FlightCreditStatusEnum = {
    Active: 'active',
    PartiallyRedeemed: 'partially_redeemed',
    FullyRedeemed: 'fully_redeemed',
    Expired: 'expired'
} as const;
export type FlightCreditStatusEnum = typeof FlightCreditStatusEnum[keyof typeof FlightCreditStatusEnum];

/**
 * @export
 */
export const FlightCreditSourceEnum = {
    Cancellation: 'cancellation',
    Refund: 'refund',
    ScheduleChange: 'schedule_change',
    ServiceRecovery: 'service_recovery',
    Involuntary: 'involuntary',
    ManualEntry: 'manual_entry',
    AutoSave: 'auto_save'
} as const;
export type FlightCreditSourceEnum = typeof FlightCreditSourceEnum[keyof typeof FlightCreditSourceEnum];


/**
 * Check if a given object implements the FlightCredit interface.
 */
export function instanceOfFlightCredit(value: object): value is FlightCredit {
    return true;
}

export function FlightCreditFromJSON(json: any): FlightCredit {
    return FlightCreditFromJSONTyped(json, false);
}

export function FlightCreditFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightCredit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'airline': json['airline'] == null ? undefined : json['airline'],
        'creditType': json['credit_type'] == null ? undefined : json['credit_type'],
        'creditNumber': json['credit_number'] == null ? undefined : json['credit_number'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'remainingAmount': json['remaining_amount'] == null ? undefined : json['remaining_amount'],
        'expirationDate': json['expiration_date'] == null ? undefined : (new Date(json['expiration_date'])),
        'status': json['status'] == null ? undefined : json['status'],
        'originalConfirmationNumber': json['original_confirmation_number'] == null ? undefined : json['original_confirmation_number'],
        'source': json['source'] == null ? undefined : json['source'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function FlightCreditToJSON(json: any): FlightCredit {
    return FlightCreditToJSONTyped(json, false);
}

export function FlightCreditToJSONTyped(value?: FlightCredit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'airline': value['airline'],
        'credit_type': value['creditType'],
        'credit_number': value['creditNumber'],
        'amount': value['amount'],
        'currency': value['currency'],
        'remaining_amount': value['remainingAmount'],
        'expiration_date': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString().substring(0,10),
        'status': value['status'],
        'original_confirmation_number': value['originalConfirmationNumber'],
        'source': value['source'],
        'notes': value['notes'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

